import { connect } from 'react-redux'
import ChangePassword from './components/Login/ChangePassword'

const mapDispatchToProps = dispatch => ({
    dispatch
})

export default connect((state) => ({ auth: state.auth }), mapDispatchToProps)(ChangePassword)
